import React from "react";
import { AlertCircle, ArrowRight } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { GenericType } from "@/types";
interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
  errorInfo: GenericType;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
  errorInfo,
}) => {
  return (
    <div className="px-5 py-5">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle className="text-xl">An error occurred:</AlertTitle>
        <AlertDescription>{error.message} </AlertDescription>
        <Collapsible>
          <CollapsibleTrigger className="text-md mt-3 flex items-center gap-1">
            componentStack: <ArrowRight size={15} />
          </CollapsibleTrigger>
          <CollapsibleContent>{errorInfo}</CollapsibleContent>
        </Collapsible>

        <Button
          className="mt-4 ml-6"
          variant={"secondary"}
          onClick={resetErrorBoundary}
        >
          Try Again
        </Button>
      </Alert>
    </div>
  );
};

export default ErrorFallback;
